import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonHeaderComponent, DownloadAppData } from '../common-header.component';
import { MainTitle } from "../../main-title/main-title.component";
import { MediaPictureService } from "../../../services/media-picture.service";

@Component({
  selector: 'heading-app',
  template: `
    <div class="heading-app" [ngClass]="{'inverted': invertedBackground}"
      [ngStyle]="{'backgroundColor': module.background_color || 'var(--brand-primary-1)', height: downloadAppData.background_max_height}">

      <div *ngIf="!!backgroundImage" class="side image-side"> 
        <img 
        [src]="backgroundImage" 
        [ngStyle]="{'max-height': downloadAppData.background_max_height}" 
        [alt]="module.data.background.alt || 'background'">
      </div>

      <div class="side titles-side">
        <div class="title-side-container title-side-horizontal-{{mainTitle.text_horizontal_align}}">
          <ng-container *ngIf="!titleInNavBar">
            <tag-text class="pretitle-container" *ngIf="mainTitle.pre_title" [data]="mainTitle.pre_title"></tag-text>
            <tag-text class="title-container -eva-3-mb-sm" *ngIf="mainTitle.title" [data]="mainTitle.title"></tag-text>
            <span class="subtitle-wrapper">
              <tag-text class="subtitle-container" *ngIf="mainTitle.sub_title" [data]="mainTitle.sub_title"></tag-text>
            </span>
          </ng-container>
          <eva-button *ngIf="downloadAppData?.mobile_button" class="-eva-3-mt-xxlg"
                      [options]="downloadAppData.mobile_button"
                      [moduleId]="'HeadingModule'"
                      [moduleIndex]="0" [uniqueId]="module.unique_id"></eva-button>
        </div>
        <div *ngIf="screenType.toString() !== 'MOBILE' && downloadAppData" class="download-container">
          <div class="download-text -eva-3-mb-lg">
            <tag-text class="title-container -eva-3-mb-sm" *ngIf="downloadAppData.title"
                      [data]="downloadAppData.title"></tag-text>
            <tag-text class="title-container -eva-3-mb-sm" *ngIf="downloadAppData.subtitle"
                      [data]="downloadAppData.subtitle"></tag-text>
          </div>
          <div class="download-methods">
            <img *ngIf="downloadAppData?.qr_image" class="qr" loading="lazy"
                 [src]="mediaPictureService.getMediaUrl(downloadAppData.qr_image, '105x105')" alt="qr"/>
            <div class="stores">
              <a
                *ngIf="downloadAppData.android_data && downloadAppData.android_data.store_image && downloadAppData.android_data.download_link"
                [href]="downloadAppData.android_data.download_link">
                <img class="badge-store android -eva-3-mb-lg" loading="lazy"
                     [src]="mediaPictureService.getMediaUrl(downloadAppData.android_data.store_image)" alt="android link"/>
              </a>
              <a
                *ngIf="downloadAppData.ios_data && downloadAppData.ios_data.store_image && downloadAppData.ios_data.download_link"
                [href]="downloadAppData.ios_data.download_link">
                <img class="badge-store ios" loading="lazy"
                     [src]="mediaPictureService.getMediaUrl(downloadAppData.ios_data.store_image)" alt="ios link"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="downloadAppData.link_to_site" class="visit-site-bar -eva-3-tc -eva-3-pb-xlg -eva-3-pt-xlg button-horizontal-{{mainTitle.text_horizontal_align}}">
      <eva-button [options]="{ghost_button: false, type: downloadAppData.link_to_site.type, size: downloadAppData.link_to_site.size,
                      link: downloadAppData.link_to_site.link ,link_text: downloadAppData.link_to_site.link_text}"
                  [moduleId]="'HeadingModule'"
                  [moduleIndex]="0" [uniqueId]="module.unique_id"></eva-button>
    </div>
  `,
  styleUrls: ['./heading-app.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeadingAppComponent extends CommonHeaderComponent implements OnInit {

  mainTitle: MainTitle;
  downloadAppData: DownloadAppData;
  backgroundImage?: string | null;
  invertedBackground?: boolean;

  constructor(injector: Injector, public mediaPictureService: MediaPictureService) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.mainTitle = this.module.data.main_title;
    this.downloadAppData = this.module.data.download_app_data;
    this.invertedBackground = this.module.data.background.inverted_background;

    this.resolveBackgroundImage();
  }

  private resolveBackgroundImage(): void {
    const picture = this.module?.data?.background?.picture;

    this.backgroundImage = picture?.trim()
    ? this.mediaPictureService.getMediaUrl(picture)
    : null;
  }
}
